import {motion} from "framer-motion";
import {Link} from "react-router-dom";
import styled from "styled-components";

export const Container = styled(motion.div)`
  top: 50%;
  z-index: 999;
  height: 50vh;
  width: 270px;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 1rem;
  padding: 1rem 0.8rem;
  transform: translate(-30%, -50%);
  background-color: ${({theme}) => theme["container"]};

  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export const NavItem = styled(Link)`
  cursor: pointer;
  padding: 0.7rem 0.8rem;
  border-radius: 0.5rem;
  text-decoration: none;
  transition: all ease 0.3s;

  &:hover {
    background-color: ${({theme}) => theme["hover"]};
  }
`;

export const Frame = styled.div`
  padding: 1px;
  width: auto;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  border: 2px solid ${({theme}) => theme["primary"]};
`;
